import apiHandler from "@/utils/handlers/ApiConnectionHandler";
import {REGISTER_FAILURE, SET_API_KEY} from "@/store/mutations";

export const SEND_REGISTRATION = 'sendRegistration';

// apiKey: "ILt7MUw9dNiDaGxKST5sr0JflkZyvcop"
// email: "Test"
// name: "cmstest@d-tt.nl"
export const actions = {
  // eslint-disable-next-line no-unused-vars
  sendRegistration({commit}, payload) {
    return apiHandler.post(`register`, undefined, payload).then(response => {
      if (response) {
        commit(SET_API_KEY, response.data.apiKey);
        return true;
      }
      return false
    }).catch((error) => {
      commit(REGISTER_FAILURE, error.response.data);
      console.error(error.response.data);
      return false
    });
  }
}
